module.exports = __webpack_public_path__ + "static/media/chess.6cdddef0.png";